// components
import WashingInstructionContainer from "./washing-instructions";
import { ItemStatusTag } from "shared/components/customers/boxes/common/item-figure/item-status-tag";

// pipes
import { Ellipsis } from "shared/pipes/ellipsis";

const ProductRow = ({ product, onRemove, washing = true }) => {

    const handleDelete = () => {
        onRemove(product);
    }

    return (
        <article className="media has-background-info-light  pb-5">

            <figure className="media-left">
                <p className="image is-64x64">
                    <img src={product.imageURLs[0]} alt={product.barcode} />
                </p>
            </figure>

            <div className="media-content">
                <div className="content mt-4">

                    <strong>{product.barcode}</strong>
                    <br />
                    <Ellipsis>{product.name}</Ellipsis>

                    <br />
                    <ItemStatusTag item={product} />

                    {/* If the product is from overstock, the supplier should be displayed */}
                    <span className="ml-1">
                        {product.model_ref && (
                            <span className="tag is-primary is-dark my-1">
                                <strong>{product.supplier}</strong>
                            </span>
                        )}
                    </span>

                    {/* If the product is made out of denim, it should be displayed */}
                    <span className="ml-1">
                        {product.details?.includes('Denim') && (
                            <span className="tag is-primary is-inverted is-dark my-1">
                                <strong>Denim</strong>
                            </span>
                        )}
                    </span>
                    <span className="ml-1">

                        <span className="tag is-primary is-inverted is-secondary my-1">
                            <strong>{product?.size}</strong>
                        </span>

                    </span>

                </div>
            </div>

            {washing && (
                <div className="media-right m-5">
                    <WashingInstructionContainer product={product} />
                </div>
            )}


            <div className="media-right p-4">
                <button className="delete" onClick={handleDelete} />
            </div>

        </article>
    );
}

export { ProductRow };
